import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { YenCircleIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
import { viewPrice } from '@/utils/resources/solution/solutionResource';
/**
 * プロジェクト事例の予算情報を表示するコンポーネント
 * @constructor
 */
export const CSearchSolutionPriceIconText = (props) => {
    const { className = '', price: propPrice } = props;
    const price = useMemo(() => `${viewPrice(propPrice)}万円程度`, [propPrice]);
    return (_jsxs(IconTextGroup, Object.assign({ className: className, space: 'wide' }, { children: [_jsx(YenCircleIcon, { color: 'base', size: 'sm' }), _jsx(Text, Object.assign({ className: 'whitespace-nowrap !leading-none', isBold: true, size: 'sm' }, { children: price }))] })));
};
